import { render, staticRenderFns } from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=template&id=1d365ae8&scoped=true&"
import script from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=style&index=0&id=1d365ae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d365ae8",
  null
  
)

export default component.exports